// @flow
import { config } from '../config'

// Types
type JWTTokenData = {
  token?: string,
  refresh_token?: string,
}

// utils
export class MemoryStorage {
  storage: { [status: string]: any }

  constructor() {
    this.storage = {}
  }

  getItem(key: string): any {
    return this.storage[key]
  }

  setItem(key: string, value: any) {
    this.storage[key] = value
  }

  removeItem(key: string) {
    delete this.storage[key]
  }
}

let memoryStorage = null
export const getCredentialsStorage = () => {
  if (config.CREDENTIALS_STORAGE_TYPE === 'Memory') {
    memoryStorage = memoryStorage || new MemoryStorage()
    return memoryStorage
  }
  return window.localStorage
}

// API functions
export function deleteJWTToken() {
  const storage = getCredentialsStorage()
  if (storage.getItem(config.AUTH_TOKEN_ID)) {
    storage.removeItem(config.AUTH_TOKEN_ID)
  }
  if (storage.getItem(config.REFRESH_TOKEN_ID)) {
    storage.removeItem(config.REFRESH_TOKEN_ID)
  }
}

export function saveJWTToken<T: JWTTokenData>(res: T): T {
  const storage = getCredentialsStorage()
  if (!res || !res.token) return res
  storage.setItem(config.AUTH_TOKEN_ID, res.token)
  storage.setItem(config.REFRESH_TOKEN_ID, res.refresh_token || '')
  return res
}

export function getRefreshToken(): ?string {
  const storage = getCredentialsStorage()
  return storage.getItem(config.REFRESH_TOKEN_ID) || null
}

export function getAuthorizationToken(): string {
  const storage = getCredentialsStorage()
  return storage.getItem(config.AUTH_TOKEN_ID) || ''
}
